import React from "react";
import Reveal from "../components/Reveal";
import { agents } from "../data/agents";

const Agents = () => (
    <div data-testid="page-agents">
        <section className="relative pt-44 pb-20">
            <div className="max-w-5xl mx-auto px-6 text-center">
                <Reveal>
                    <p className="text-[0.7rem] tracking-[0.55em] uppercase text-brand-gold mb-6">The Partners</p>
                    <h1 className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl text-brand-silver leading-[1.05]">
                        Six advisors. <span className="italic text-brand-champagne">One standard.</span>
                    </h1>
                    <p className="mt-8 text-brand-silver/75 max-w-2xl mx-auto leading-relaxed">
                        Every mandate is personally handled by one of the firm's named partners or directors.
                        No junior handoffs. No assembly line.
                    </p>
                </Reveal>
            </div>
        </section>

        <section className="pb-28">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                {agents.map((a, i) => (
                    <Reveal key={a.id} delay={i * 100}>
                        <article
                            className="group relative overflow-hidden border border-white/10 hover:border-brand-gold/50 transition-all duration-500 bg-brand-onyx"
                            data-testid={`agent-card-${a.id}`}
                        >
                            <div className="aspect-[3/4] overflow-hidden relative">
                                <img
                                    src={a.image}
                                    alt={a.name}
                                    className="img-zoom w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                            </div>
                            <div className="p-7">
                                <h3 className="font-serif-editorial text-2xl text-brand-champagne">{a.name}</h3>
                                <p className="mt-1 text-[0.7rem] tracking-[0.3em] uppercase text-brand-gold">{a.title}</p>
                                <p className="mt-5 text-sm text-brand-silver/65 leading-relaxed">{a.bio}</p>
                                <div className="mt-6 flex flex-wrap gap-2">
                                    {a.specialties.map((s) => (
                                        <span
                                            key={s}
                                            className="text-[0.6rem] tracking-[0.25em] uppercase border border-brand-silver/20 text-brand-silver/70 px-3 py-1"
                                        >
                                            {s}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    </div>
);

export default Agents;
